import React, { useEffect } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";

const PlFuelEnteryFailureModal = React.forwardRef((props, ref) => {
  // Handle form OK
  const okConfirm = async () => {
    props.onHide();
  };

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  return (
    // backdrop="static"
    <Modal
      {...props}
      size="md"
      ref={ref}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header>
        <Modal.Title>
          <i className="bi bi-exclamation-triangle"></i>
          <span className="modal-title"> Warning</span>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="text-danger">
          {props.requiredfields?.map((item, index) => (<div className="d-flex justify-content-center">
            <h5 key={index}>
              <i className="bi bi-x-circle-fill text-danger mx-2"></i> 
            </h5>
            <p className="text-dark fw-bold fs-5">{item}</p>
            </div>
          ))}
        </div>

        <Row className="mt-4">
          <Col sm={{span:4,offset:6}} md={{span:4,offset:6}} lg={{span:4,offset:6}}>
            <button
              type="button"
              onClick={props.onConfirm}
              className="btn btn-primary"
            >
              OK (Continue)
            </button>
          </Col>

          <Col sm={2} md={2} lg={2}>
            <button
              type="button"
              onClick={okConfirm}
              className="btn btn-danger"
            >
              Cancel
            </button>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
});

export default PlFuelEnteryFailureModal;
